<template>
  <div class="bg-neutral-white">
    <CCol sm="12" xs="6" class="text-right">
      <h5 class="custom-18px poppin-font mt-2 text-center" style="padding-top: 40px;">
        <img style="max-width: 40px; float: left; margin-right: 10px;margin-top:-5px" src="../assets/img/arrow-left.png" alt="Arrow Left Image" @click="GoToPrevious()" />
          <span style="margin-top:20px">Settings</span>
      </h5>
      
    </CCol>
    <div style="clear:both"></div>
    <br />
    <CCol sm="12">
      <div class="m-0 justify-content-center align-items-center">
        <div class="bg-purple-card-setting">
          <div class="header-top" style="text-align: left;">
            <CRow>
              <span class="custom-header-profile ml-3">
                <img src="../assets/img/tirta.png" style="width: 40px" />
              </span>
              <div>
                <span>
                  <label class="text-icon custom-font-cards" style="margin-bottom: 0px; text-align: left;">Siti Tirta Dinar</label> <br />
                  <label class="text-icon custom-font-cards">sititirtadinar@gmail.com</label>
                </span>
                <span>
                  <span style="position: absolute; top: 12px; right: 30px;">
                    <img src="../assets/img/edit.png" style="width: 35px" @click="GoToEdit()" />
                  </span>
                </span>
                <div style="clear: both"></div>
              </div>
            </CRow>
          </div>
        </div>

        <br />

        <CCard class="border-white-setting">
          <CCol sm="12">
            <h3 class="custom-12px" style="padding: 10px;">Account</h3> 
            <span>
              <img src="../assets/img/lock.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> Change Password </label>
              <div class="float-right">
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToChangePassword()" />
              </div>
            </span>
            <hr />

            <span>
              <img src="../assets/img/location-2.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> Address </label>
              <div class="float-right">
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToLocation()" />
              </div>
            </span>
            <br /><br />
          </CCol>
        </CCard>

        <CCard class="border-white-setting">
          <CCol sm="12">
            <h3 class="custom-12px" style="padding: 10px;">General</h3> 
            <span>
              <img src="../assets/img/country-flag.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> Country </label>
              <div class="float-right">
                <label class="custom-14px"> Malaysia </label>
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToCountry()" />
              </div>
            </span>
            <hr />

            <span>
              <img src="../assets/img/currency.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> Currency </label>
              <div class="float-right">
                <label class="custom-14px"> MYR </label>
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToCurrency()" />
              </div>
            </span>
            <hr />

            <span>
              <img src="../assets/img/language.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> Language </label>
              <div class="float-right">
                <label class="custom-14px"> English </label>
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToLanguage()" />
              </div>
            </span>
            <hr />

            <span>
              <img src="../assets/img/notification-2.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> Notification </label>
              <div class="float-right">
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToNoti()" />
              </div>
            </span>
            <hr />

            <span>
              <img src="../assets/img/socmed-link.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> Social Media Link </label>
              <div class="float-right">
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToSocmed()" />
              </div>
            </span>
            <br /><br />
          </CCol>
        </CCard>

        <CCard class="border-white-setting">
          <CCol sm="12">
            <h3 class="custom-12px" style="padding: 10px;">More</h3> 
            <span>
              <img src="../assets/img/24-support.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> Help & Support </label>
              <div class="float-right">
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToHelp()" />
              </div>
            </span>
            <hr />

            <span>
              <img src="../assets/img/info-circle.png" style="width: 24px;" class="mr-2" />
              <label class="custom-font-setting"> About Us </label>
              <div class="float-right">
                <img src="../assets/img/arrowright.png" style="width: 35px" @click="GoToAbout()" />
              </div>
            </span>
            <br /><br />
          </CCol>
        </CCard>

        <CButton type="button" class="button-border-red mt-4 mb-5" block @click="Logout()">Log Out</CButton>
        <br /><br />
      </div>
    
      <div v-if="logoutPopup == true" class="popup-all backdrop-all" @click="closePopup">
        <div class="popup-all1">
          <!-- Popup content -->
          <div class="text-center">
            <img style="max-width:100%" src="../assets/img/logout.png" />
            <h3 class="custom-18px-500 text-center"><strong>Log Out!</strong></h3>
            <h3 class="custom-10px text-center">Are you sure you want to logout ?</h3>
            <CRow>
              <CButton type="button" class="button-border-blue mt-4" style="width: 50%; background: transparent; color: #212529;" block>Cancel</CButton>
              <CButton type="button" class="button-border-blue text-white mt-4" style="width: 50%" block @click="openApplySuccess()">Log Out</CButton>
              <div style="clear: both"></div>
            </CRow>
          </div>
        </div>
      </div>       
    
    
    
    </CCol>
  </div>
</template>


<script>
import MainlayoutBottom from "../containers/TheBottomCustom.vue";
import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination,
} from "hooper";

import "hooper/dist/hooper.css";
export default ({
    components: {
        Hooper,
        Slide,
        HooperNavigation,
        HooperPagination,
        MainlayoutBottom,
    },
    data() {
        return {
            isLanguagePopupVisible: false,
            code: ["", "", "", ""],
            hooperSettings1: {
                hideArrows: true,
            },
            logoutPopup: false,

        }

    },
    methods: {
        GoToPrevious() {
            this.$router.go(-1);
        },

        GoToLogin() {
            // Close the popup and backdrop
            this.$router.push("/RegisterHomepage");
        },

        
        submitVerification() {
            const verificationCode = this.code.join(""); // Concatenate the digits
            console.log("Verification Code:", verificationCode);

            this.popupSuccess = true;

            // Add your logic to handle the verification code
        },

        Logout() {
          this.logoutPopup = true;
        },

        GoToEdit() {
          this.$router.push("/EditProfile");
        },

        GoToChangePassword() {
          this.$router.push("/ChangePassword2");
        },

        GoToLocation() {
          this.$router.push("/Location");
        },

        GoToCountry() {
          this.$router.push("/EditCountry");
        },

        GoToCurrency() {
          this.$router.push("/EditCurrency");
        },

        GoToLanguage() {
          this.$router.push("/EditLanguage");
        },

        GoToNoti() {
          this.$router.push("/NotificationSetting");
        },

        GoToSocmed() {
          this.$router.push("/EditSocmed");
        },

        GoToHelp() {
          this.$router.push("/HelpSupport");
        },

        GoToAbout() {
          this.$router.push("/AboutUs");
        },

       


    }
})
</script>

<style scoped>
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
</style>